import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Chip,
    Avatar,
    Button,
    TextField
} from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SendIcon from "@mui/icons-material/Send";

const ActionChip = ({ label, active }) => (
    <Chip
        label={label}
        clickable
        sx={{
            borderRadius: 5,
            px: 1,
            bgcolor: active ? "#f26522" : "#f3f4f6",
            color: active ? "#fff" : "#333",
            fontWeight: 500,
            "&:hover": {
                bgcolor: active ? "#e65a1c" : "#e5e7eb"
            }
        }}
    />
);

const AIPayrollAssistant = () => {
    return (
        <Card className="mt-3 mt-lg-0 h-100"
            sx={{
                borderRadius:"5px",
                background: "linear-gradient(180deg,#fdf2e9,#f6f6f6)",
                height: "100%",          
                display: "flex",         
                flexDirection: "column"  ,
                border: "1px solid #eee"
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    height: "100%"   // ✅ ADD
                }}
            >

                {/* HEADER */}
                <Box mb={3} display="flex" justifyContent="space-between">

                    <Box display="flex" gap={2}>
                        <Avatar sx={{ bgcolor: "#111", width: 50, height: 50 }}>
                            <SmartToyOutlinedIcon />
                        </Avatar>

                        <Box>
                            <Typography fontWeight={700}>
                                How can I help you today
                            </Typography>
                            <Typography fontSize={13} color="text.secondary">
                                AI Payroll Assistant
                            </Typography>
                        </Box>
                    </Box>

                    <Chip
                        label="Online"
                        size="small"
                        sx={{
                            bgcolor: "#22c55e",
                            color: "#fff",
                            fontWeight: 500
                        }}
                    />
                </Box>

                {/* QUICK ACTIONS */}
                <Box mb={3}>
                    <Typography fontWeight={600} mb={1}>
                        Quick Actions
                    </Typography>

                    <Box display="flex" flexWrap="wrap" gap={1}>
                        <ActionChip label="Calculate overtime pay" active />
                        <ActionChip label="Generate tax report" />
                        <ActionChip label="Error Detection" />
                        <ActionChip label="Compliance Monitoring" />
                        <ActionChip label="Analyze salary trends" />
                        <ActionChip label="Review payroll errors" />
                    </Box>
                </Box>

                {/* MESSAGE */}
                <Box
                    sx={{
                        border: "1px solid #eee",
                        borderRadius: 3,
                        p: 2,
                        mb: 3,
                        bgcolor: "#fff"
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <AutoAwesomeIcon sx={{ color: "#f26522", fontSize: 18 }} />
                        <Typography fontWeight={600} color="#f26522">
                            AI Assistant
                        </Typography>
                    </Box>

                    <Typography fontSize={14} mb={1}>
                        Hello! I'm your AI Payroll Assistant. I can help you with payroll calculations, tax questions, compliance issues. How can I assist you today?
                    </Typography>

                    <Typography fontSize={12} color="text.secondary">
                        11:45 PM
                    </Typography>
                </Box>

                {/* SUGGESTIONS */}

                {/* BOTTOM SECTION */}
                <Box mt="auto">

                    {/* SUGGESTIONS */}
                    <Box mb={2}>
                        <Typography fontWeight={600} mb={1}>
                            Suggested Questions
                        </Typography>

                        <Typography fontSize={14} color="text.secondary">
                            How do I process a bonus payment? What are the tax implications of workers?
                        </Typography>
                    </Box>

                    {/* INPUT */}
                    <Box display="flex" alignItems="center" gap={1}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Ask me anything about payroll"
                            sx={{
                                bgcolor: "#f3f4f6",
                                borderRadius: 5
                            }}
                        />

                        <Button
                            variant="contained"
                            sx={{
                                minWidth: 40,
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                bgcolor: "#f26522"
                            }}
                        >
                            <SendIcon />
                        </Button>
                    </Box>

                </Box>
            </CardContent>
        </Card>
    );
};

export default AIPayrollAssistant;